import { render, staticRenderFns } from "./PaymentBrand.vue?vue&type=template&id=ddc23e88&scoped=true"
import script from "./PaymentBrand.vue?vue&type=script&lang=js"
export * from "./PaymentBrand.vue?vue&type=script&lang=js"
import style0 from "./PaymentBrand.vue?vue&type=style&index=0&id=ddc23e88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc23e88",
  null
  
)

export default component.exports